import { Modal } from '@gerdau/hefesto/Modal';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { sendTagging } from '../../../../../store/ducks/tagging/actions';
import { getTaggingInformationScreen } from '../../../../../utils/Tagging';
import { useHistory } from 'react-router-dom';
import { EFabricationRoutes } from '../../fabrication.routes';

interface ILoadingFabricationOrderModalProps {
  loading: boolean;
  error: boolean;
  orderNumber?: string;
  onClose(): void;
}

const LoadingFabricationOrderModal: React.FC<
  ILoadingFabricationOrderModalProps
> = ({ loading, error, orderNumber, onClose }) => {
  const dispatch = useDispatch();

  const { screenName = '', itemDescription } = getTaggingInformationScreen(
    'construction-identification-modal-rebuy',
    true
  );

  const { location } = useHistory();

  useEffect(() => {
    dispatch(
      sendTagging({
        event: 'page_view',
        page: location.pathname,
        screenName
      })
    );
  }, []);

  return (
    <>
      <Modal
        title="Recomprar último pedido"
        onClose={() => {
          onClose();
        }}
        buttons={{
          left: {
            children: 'Fechar',
            name: 'Fechar',
            loading,
            disabled: loading,
            onClick: () => {
              onClose();
              dispatch(
                sendTagging({
                  event: 'click',
                  itemName: 'button:fechar',
                  itemDescription: `${itemDescription}Pedido_fechar`,
                  screenName
                })
              );
            }
          },
          right: {
            children: 'Ok',
            name: 'Ok',
            loading,
            disabled: loading,
            onClick: () => {
              onClose();
              location.pathname.includes(EFabricationRoutes.LAST_ORDERS) &&
                history.back();
              dispatch(
                sendTagging({
                  event: 'click',
                  itemName: 'button:ok',
                  itemDescription: `${itemDescription}Pedido_ok`,
                  screenName
                })
              );
            }
          }
        }}
      >
        {loading && (
          <>
            Carregando informações sobre o pedido <b>{orderNumber}</b>...
          </>
        )}

        {!loading && !error && (
          <>
            As informações do pedido <b>{orderNumber}</b> foram replicadas.{' '}
            <br />
            Insira um novo código, revise o pedido e clique em concluir pedido
            para confirmar a compra.
          </>
        )}

        {!loading && error && (
          <>
            Falha ao buscar as informações do pedido <b>{orderNumber}</b>.{' '}
            <br />
            Tente novamente.
          </>
        )}
      </Modal>
    </>
  );
};

export default LoadingFabricationOrderModal;
